import React, { useEffect } from 'react'
import Spinner from './_utils/Spinner'
import { isDeepEqual, LogFancy } from '../libraries/Helpers'
import classNames from 'classnames'
import Action from './Action'
import List from './List'
import Node from './Node'


export default function TreeComponent(props) {


    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">

                    <button type="button" className="btn btn-outline-success"><i className="fa fa-play"></i></button>
                    <button type="button" className="btn btn-outline-warning"><i className="fa fa-pause"></i></button>
                    <button type="button" className="btn btn-outline-dark"><i className="fa fa-stop"></i></button>

                </div>
            </div>
        </div>
    )
}